export default {"src":"/_next/static/media/wishlist.edac01ef.svg","height":24,"width":24};